import ValidatorService from "@/services/ValidatorService";
import NotificationServicesService from "@/services/NotificationServicesService";

const state = {
  testTypeId: null,
  formGeneral: {
    name: ''
  },

  formTestMethod: {
    testMethod: {testConfig: {}},
    testMethodConfig: {},
  },

  formValidator: {
    validators: []
  },

  formNotificationService: {
    notificationService: {
      error: {notificationConfig: {}},
      warning: {notificationConfig: {}},
      testResult: {notificationConfig: {}}
    },
    notificationServiceConfig: {
      error: {},
      warning: {},
      testResult: {}
    }
  }
}

const getters = {
  formGeneral: state => {
    return state.formGeneral
  },

  formTestMethod: state => {
    return state.formTestMethod
  },

  formNotificationService: state => {
    return state.formNotificationService
  },

  formValidator: state => {
    return state.formValidator
  },

  testTypeRequestData: state => {
    let notificationServices = {};
    let validators = [];

    for (let validatorItem of state.formValidator.validators) {
      if (validatorItem.validator._id) {
        validators.push({
          id: validatorItem.validator._id,
          validatorConfig: validatorItem.config
        })
      }
    }

    if (state.formNotificationService.notificationService.error && state.formNotificationService.notificationService.error._id) {
      notificationServices.error = {
        notificationServicesId: state.formNotificationService.notificationService.error._id,
        config: state.formNotificationService.notificationServiceConfig.error
      }
    }

    if (state.formNotificationService.notificationService.warning && state.formNotificationService.notificationService.warning._id) {
      notificationServices.warning = {
        notificationServicesId: state.formNotificationService.notificationService.warning._id,
        config: state.formNotificationService.notificationServiceConfig.warning
      }
    }

    if (state.formNotificationService.notificationService.testResult && state.formNotificationService.notificationService.testResult._id) {
      notificationServices.testResult = {
        notificationServicesId: state.formNotificationService.notificationService.testResult._id,
        config: state.formNotificationService.notificationServiceConfig.testResult
      }
    }

    return {
      name: state.formGeneral.name,
      testMethod: state.formTestMethod.testMethod._id,
      testConfig: state.formTestMethod.testMethodConfig,
      notificationServices: notificationServices,
      validators: validators
    }
  }
}

const actions = {
  addValidator(context) {
    context.commit('addValidator')
  },

  removeValidator(context, index) {
    context.commit('removeValidator', index)
  },

  setForUpdate(context, testType) {
    context.commit('setForUpdate', testType)
  }
}

const mutations = {
  addValidator (state) {
    state.formValidator.validators.push({
      validator: {validatorConfig:{}},
      config:{}
    })
  },

  removeValidator (state, index) {
    state.formValidator.validators.splice(index, 1)
  },

  setForUpdate (state, testType) {
    state.testTypeId = testType._id;
    state.formGeneral.name = testType.name;
    state.formTestMethod.testMethod = testType.testMethod;
    state.formTestMethod.testMethodConfig = testType.testConfig;

    for (let testTypeValidator of testType.validators) {
      ValidatorService.get(testTypeValidator.id).then(response => {
        state.formValidator.validators.push({
          validator: response.data,
          config: testTypeValidator.validatorConfig
        })
      })
    }

    if (testType.notificationServices.error) {
      NotificationServicesService.get(testType.notificationServices.error.notificationServicesId)
        .then(response => {
          state.formNotificationService.notificationService.error = response.data;
          state.formNotificationService.notificationServiceConfig.error = testType.notificationServices.error.config
        })
    }

    if (testType.notificationServices.warning) {
      NotificationServicesService.get(testType.notificationServices.warning.notificationServicesId)
        .then(response => {
          state.formNotificationService.notificationService.warning = response.data;
          state.formNotificationService.notificationServiceConfig.warning = testType.notificationServices.warning.config
        })
    }

    if (testType.notificationServices.testResult) {
      NotificationServicesService.get(testType.notificationServices.testResult.notificationServicesId)
        .then(response => {
          state.formNotificationService.notificationService.testResult = response.data;
          state.formNotificationService.notificationServiceConfig.testResult = testType.notificationServices.testResult.config
        })
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
